import Cookies from 'js-cookie';

export type DeviceSource = 'mobile' | 'desktop';

const SOURCE_COOKIE = 'source';

export const getDeviceSource = (): DeviceSource =>
  Cookies.get(SOURCE_COOKIE) === 'mobile' ? 'mobile' : 'desktop';

export const isMobileSource = (): boolean => getDeviceSource() === 'mobile';

export const isDesktopSource = (): boolean => getDeviceSource() === 'desktop';

const MOBILE_USER_AGENT = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export const isMobileUserAgent = (): boolean => MOBILE_USER_AGENT.test(navigator.userAgent ?? '');
